<div class="d-flex align-items-center">
    <label for="" class="mr-2 m-0 w-auto">Asset Type</label>
    <select class="form-control common_select" name="selectedValue" [(ngModel)]="selectedValue" (change)="onSelectChanges($event)">
        <option *ngFor="let r of selectOptionsArr" [value]="r.value">
            {{ r.name }}
        </option>
    </select>
</div>